<template lang="pug">
  v-container(v-if="$route.name === 'home'" fluid style="max-width: 600px;")
    v-slide-y-transition(mode="out-in")
      v-layout(column align-center)
        v-container(fluid)
          img(src="@/assets/anre-logo-300.png" style="max-width:50%; display:block; margin: 0 auto" alt="ANRE logo" class="mb-5")

          v-list(one-line)
            template(v-for="(newsItem, k) in newsMenu")
              v-divider(v-if="k > 0" inset)
              v-list-tile(:key="newsItem.tip" :to="{name: 'noutati.list', params: { tip: newsItem.tip }}" avatar ripple)
                v-list-tile-avatar
                  v-icon {{ newsItem.icon }}
                v-list-tile-title
                  span {{ newsItem.label }}
                  v-badge(v-if="newsItem.unreadCount > 0" color="error")
                    span(slot="badge") {{ newsItem.unreadCount }}
            v-divider
            v-subheader Comparatoare oferte-tip furnizare
            v-list-tile(:to="{name: 'electric'}" avatar ripple)
              v-list-tile-avatar
                v-icon power
              v-list-tile-title {{ k.energie_electrica_label }}
            v-divider(inset)
            v-list-tile(:to="{name: 'gaz'}" avatar ripple)
              v-list-tile-avatar
                v-icon whatshot
              v-list-tile-title {{ k.gaze_naturale_label }}
  router-view(v-else)
</template>
<script>
  import keywords from '@/modules/home/lang/index.js';
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        loading: false
      };
    },
    computed: {
      ...mapState({
        language: s => s.lang.lang,
        newsUnreadCount: s => s.noutati.unreadCount > 99 ? 99 : s.noutati.unreadCount
      }),
      k() {
        return keywords[this.language];
      },
      newsMenu () {
        return [
          {
            tip: 'noutate',
            icon: 'forum',
            label: this.k.noutati_label,
            unreadCount: this.newsUnreadCount['noutate']
          },
          {
            tip: 'document-discutie',
            icon: 'find_in_page',
            label: this.k.documente_discutie_label,
            unreadCount: this.newsUnreadCount['document-discutie']
          },
          {
            tip: 'buletin-informativ',
            icon: 'info',
            label: this.k.buletine_informative_label,
            unreadCount: this.newsUnreadCount['buletin-informativ']
          }
        ];
      }
    },
    mounted() {
      this.loading = true;
      this.$store.dispatch('noutati/updateUnreadCount')
        .finally(() => this.loading = false);
    }
  }
</script>
<style lang="stylus">
  h1, h2
    font-weight normal

  ul
    list-style-type none

    padding 0
  li
    display inline-block
    margin 0 10px

  a
    color: #42b983

  .v-badge__badge
    position static
    margin-left 10px

</style>
